import { BrowserOptions } from '@sentry/react';

import { getCurrentEnvironment, parseEnv } from './common';

export const getSentryConfig = (): Pick<
  BrowserOptions,
  'release' | 'dsn' | 'environment' | 'debug' | 'enabled'
> => {
  const debug = parseEnv(process.env.SENTRY_DEBUG as unknown as string) as unknown as boolean;
  const enabled = parseEnv(process.env.SENTRY_ENABLED as unknown as string) as unknown as
    | boolean
    | undefined;
  const isReleaseBranch = parseEnv(
    process.env.RELEASE_BRANCH as unknown as string,
  ) as unknown as boolean;

  return {
    release: process.env.SENTRY_RELEASE,
    dsn: process.env.SENTRY_DSN,
    environment: getCurrentEnvironment(),
    debug,
    /**
     * Если в .env есть переменная SENTRY_ENABLED то смотрим на неё, если нет то по-умолчанию сентри будет работать только в релизной ветке
     */
    enabled: typeof enabled === 'boolean' ? enabled : isReleaseBranch,
  };
};
